import { PlansService } from './../../../data/repository/plans-repository/plans.service';
import { FoodFactCreate } from './../../../core/model/api-response/persoanl-response-model';
import {
  FoodFactsModel,
  FoodFactModel,
  FoodModel,
} from './../../../core/model/object/diet-food-model';
import { ShopService } from 'src/app/data/repository/shop-repository/shop.service';
import { CalendarShared } from './../../general/shared/calendar-shared';
import { FoodLogModel } from './../../../core/model/object/foodlog-model';
import { GenerateShared } from './../../general/shared/generate-shared';
import { PredefinedDietDialogComponent } from './../predefined-diet-dialog/predefined-diet-dialog.component';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { Subscription } from 'rxjs';
import { PlanShared } from '../../general/shared/plan-shared';
import {
  FoodUnitRatioModel,
  FoodUnitIdModel,
} from 'src/app/core/model/object/diet-food-model';
import { ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { EditFoodBottomsheetComponent } from '../edit-food-bottomsheet/edit-food-bottomsheet.component';
import { TutorialShared } from '../../general/shared/tutorial-shared';
import { TutorialService } from 'src/app/data/repository/tutorial-repository/tutorial.service';
import { TutorialInputModel } from 'src/app/core/model/input/tutorial-input-model';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { DialogShared } from '../../general/shared/dialog-shared';
import { IosBottomsheetInputModel } from '../../general/ios-bottomsheet/ios-bottomsheet.component';
import { PlanStatusInputModel } from 'src/app/core/model/input/plan-status-input-model';
import { AddFoodLogInputModel } from 'src/app/core/model/input/food-log-input-model';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';

@Component({
  selector: 'app-meal-detail',
  templateUrl: './meal-detail.component.html',
  styleUrls: ['./meal-detail.component.scss'],
})
export class MealDetailComponent implements OnInit, OnDestroy {
  title: string;
  day: string;
  dietId: string;
  foods = [];
  foodsAmount = [];
  foodFactsNamesBreif = [];
  foodFactsNames = [];
  foodFactsUnits = [];
  foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  status: number;
  morefoodFacts = false;
  showFoodFactDetail = false;
  muchCalorie = 0;
  littleCalorie = 0;
  selectedFood: FoodLogModel;
  dataIsReady = false;
  showTutorial = false;
  tutorialInput: TutorialInputModel;
  backToMain = true;
  isPredefined = false;
  cheatDayCount = 0;

  planStatusInput: PlanStatusInputModel;
  dayStatus = '';

  iosBottomsheetInput: IosBottomsheetInputModel;
  showIosBottomsheet = false;

  lockPlan = false;

  showLoading = false;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;
  subscription7: Subscription;
  subscription8: Subscription;
  subscription9: Subscription;
  subscription10: Subscription;
  planBottomSheet: boolean = false;
  showplanBottomSheet: boolean = false;
  constructor(
    public planService: PlanService,
    private bottomsheetShared: BottomsheetShared,
    public planShared: PlanShared,
    private route: ActivatedRoute,
    private snackBarService: SnackBarService,
    private matBottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private tutorialShared: TutorialShared,
    private tutorialService: TutorialService,
    private diaryAnalytics: DiaryAnalyticsService,
    private dialogShared: DialogShared,
    private generateShared: GenerateShared,
    private calendarShared: CalendarShared,
    private shopService: ShopService,
    public calorieCalculator: CalorieCalculator,
    private plansService: PlansService
  ) {
    this.day = this.route.snapshot.paramMap.get('day');
    this.dietId = this.route.snapshot.paramMap.get('dietId');
    this.isPredefined =
      this.route.snapshot.paramMap.get('isPredefined') === '1';
    this.cheatDayCount = parseInt(
      this.route.snapshot.paramMap.get('cheatDayCount')
    );
    this.prepareValues();
    this.subscription1 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showFoodFactDetail = false;
        }
      }
    );
    this.subscription2 =
      this.bottomsheetShared.openFoodFactBottomsheetObs$.subscribe((open) => {
        if (open) {
          this.openFoodFactsDetail();
        }
      });
    this.subscription3 = this.tutorialShared.showTutorialObs$.subscribe(
      (show) => {
        if (show && this.tutorialShared.selectedTutorial) {
          this.tutorialInput = this.tutorialShared.selectedTutorial;
          this.showTutorial = true;
        }
      }
    );
    this.subscription4 = this.tutorialShared.hideTutorialObs$.subscribe(
      (hide) => {
        if (hide) {
          this.showTutorial = false;
        }
      }
    );
    this.subscription5 =
      this.dialogShared.addFoodContinueButtonClickObs$.subscribe((clicked) => {
        if (clicked) {
          this.planService.goToPersoanlpackage(
            this.dietId,
            this.day,
            this.planShared.selectedMeal.meal
          );
        }
      });
    this.subscription6 = this.dialogShared.changePlanClickObs$.subscribe(
      (clicked) => {
        if (clicked) {
          this.generateShared.cancelDay = parseInt(this.day);
          this.openIosBottomsheet();
        }
      }
    );
    this.subscription7 =
      this.bottomsheetShared.closeIosBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.showIosBottomsheet = false;
        }
      });
    this.subscription8 =
      this.bottomsheetShared.pendingFoodsConfirmObs$.subscribe((confirm) => {
        if (confirm) {
          this.pending();
          this.showIosBottomsheet = false;
        }
      });
    this.subscription9 = this.plansService.closeBottomSheet$.subscribe(
      (close) => {
        if (close) {
          this.showplanBottomSheet = false;
          setTimeout(() => {
            this.planBottomSheet = false;
          }, 300);
        }
      }
    );
    this.subscription10 = this.plansService.openBottomSheet$.subscribe(
      (close) => {
        if (close) {
          this.planBottomSheet = true;
          setTimeout(() => {
            this.showplanBottomSheet = true;
          }, 300);
        }
      }
    );
  }

  ngOnInit() {
    this.diaryAnalytics.analyticDiaryPackageVisited();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
    this.subscription6.unsubscribe();
    this.subscription7.unsubscribe();
    this.subscription8.unsubscribe();
  }

  openIosBottomsheet() {
    this.iosBottomsheetInput = new IosBottomsheetInputModel(
      ['بله'],
      'خیر',
      'آیا میخواهید برنامه غذایی خود را پیش از موعد به پایان برسانید؟'
    );
    this.generateShared.previousUrl = 'mealDetail';
    this.showIosBottomsheet = true;
  }

  // tutorial() {
  //   const foodsBox = document.getElementsByName('food-box');
  //   if (foodsBox.length !== 0) {
  //     this.tutorialShared.foodBox = foodsBox[0];
  //   }
  //   this.tutorialShared.addFoodBox = document.getElementById('add-food-box');
  //   this.tutorialShared.packageBox = document.getElementById('package-box');
  //   this.tutorialShared.changeMealBox =
  //     document.getElementById('change-meal-box');
  //   this.tutorialShared.consumeMealBox =
  //     document.getElementById('consume-meal-box');
  //   this.tutorialService.checkSuggestedPackageTutorial();
  // }

  prepareValues() {
    this.dataIsReady = false;
    if (
      !this.planShared.selectedMeal ||
      !this.planShared.selectedDietDayFoodLogs
    ) {
      this.back();
      return;
    }
    this.lockPlan = this.planShared.lockPlan;
    this.dayStatus = this.planShared.dayStatus;

    if (this.dayStatus === 'generate') {
      this.planStatusInput = new PlanStatusInputModel(
        'generate',
        'assets/profile/diet.png',
        'شما برنامه غذایی ندارید!',
        'همین حالا برنامه غذایی تهیه کنید',
        true,
        false,
        true
      );
    }
    this.generateShared.previousUrl = 'mealDetail';
    this.foods = [];
    this.foodsAmount = [];
    this.foodFactsNamesBreif = [];
    this.foodFactsNames = [];
    this.foodFactsUnits = [];
    this.title = this.planShared.selectedMealRatio.meal_text;
    this.status =
      this.planShared.selectedMeal.status === 'passed'
        ? -1
        : this.planShared.selectedMeal.status === 'consumed'
        ? 1
        : 0;
    this.foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    let hasFoodLog = false;
    this.planShared.selectedDietDayFoodLogs.foodLogs.forEach((foodlog) => {
      if (foodlog.meal === this.planShared.selectedMeal.meal) {
        hasFoodLog = true;
        this.foods.push(foodlog);
        const ratio = this.calorieCalculator.findFoodLogRatio(foodlog);
        if (foodlog.calorie && foodlog.title) {
          this.foodsAmount.push(foodlog.calorie + ' ' + 'کالری');
        } else {
          this.foodsAmount.push(foodlog.amount + ' ' + ratio.unitId.name);
        }
        this.foodFactsAmount = this.prepareFoodFactsAmounts(
          foodlog,
          this.foodFactsAmount,
          ratio
        );
        this.foodFactsNames = this.prepareFoodFactsPersianNames(foodlog);
        this.foodFactsNamesBreif = [
          this.foodFactsNames[0],
          this.foodFactsNames[1],
          this.foodFactsNames[2],
          this.foodFactsNames[3],
        ];
        this.foodFactsUnits = this.prepareFoodFactsPersianUnits(foodlog);
      }
    });

    if (!hasFoodLog) {
      this.foodFactsAmount = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ];
      this.foodFactsNames = [
        'کالری',
        'پروتئین',
        'کربوهیدرات',
        'چربی',
        'قند',
        'فیبر',
        'سدیم',
        'پتاسیم',
        'کلسیم',
        'منیزیم',
        'فسفر',
        'آهن',
        'اسید چرب اشباع',
        'اسید های چرب تک غیر اشباع',
        'اسیدهای چرب چند غیر اشباع',
        'اسید چرب ترانس',
        'کلسترول',
      ];
      this.foodFactsNamesBreif = [
        this.foodFactsNames[0],
        this.foodFactsNames[1],
        this.foodFactsNames[2],
        this.foodFactsNames[3],
      ];
      this.foodFactsUnits = [
        'کالری',
        'گرم',
        'گرم',
        'گرم',
        'گرم',
        'گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'گرم',
        'گرم',
        'گرم',
        'گرم',
        'میلی گرم',
      ];
    }
    this.checkCalorieAmount();
    this.dataIsReady = true;
    setTimeout(() => {
      // this.tutorial();
    }, 600);
  }
  makeFoodFactsModel(f: FoodFactCreate): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }
  prepareFoodFactsAmounts(
    food: FoodLogModel,
    foodFactsAmount: number[],
    ratio: FoodUnitRatioModel
  ): number[] {
    if (food.calorie && food.title) {
      foodFactsAmount[0] = food.calorie + foodFactsAmount[0];
    } else {
      foodFactsAmount[0] =
        food.foodModel.foodFactModel.calorie.amount !== -1 &&
        this.foodFactsAmount[0] !== -1
          ? ((food.foodModel.foodFactModel.calorie.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[0]
          : 0;
      foodFactsAmount[1] =
        food.foodModel.foodFactModel.protein.amount !== -1 &&
        this.foodFactsAmount[1] !== -1
          ? ((food.foodModel.foodFactModel.protein.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[1]
          : 0;
      foodFactsAmount[2] =
        food.foodModel.foodFactModel.carbohydrate.amount !== -1 &&
        this.foodFactsAmount[2] !== -1
          ? ((food.foodModel.foodFactModel.carbohydrate.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[2]
          : 0;
      foodFactsAmount[3] =
        food.foodModel.foodFactModel.fat.amount !== -1 &&
        this.foodFactsAmount[3] !== -1
          ? ((food.foodModel.foodFactModel.fat.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[3]
          : 0;
      foodFactsAmount[4] =
        food.foodModel.foodFactModel.sugar.amount !== -1 &&
        this.foodFactsAmount[4] !== -1
          ? ((food.foodModel.foodFactModel.sugar.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[4]
          : 0;
      foodFactsAmount[5] =
        food.foodModel.foodFactModel.fiber.amount !== -1 &&
        this.foodFactsAmount[5] !== -1
          ? ((food.foodModel.foodFactModel.fiber.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[5]
          : 0;
      foodFactsAmount[6] =
        food.foodModel.foodFactModel.sodium.amount !== -1 &&
        this.foodFactsAmount[6] !== -1
          ? ((food.foodModel.foodFactModel.sodium.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[6]
          : 0;
      foodFactsAmount[7] =
        food.foodModel.foodFactModel.potassium.amount !== -1 &&
        this.foodFactsAmount[7] !== -1
          ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[7]
          : 0;
      foodFactsAmount[8] =
        food.foodModel.foodFactModel.calcium.amount !== -1 &&
        this.foodFactsAmount[8] !== -1
          ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[8]
          : 0;
      foodFactsAmount[9] =
        food.foodModel.foodFactModel.magnesium.amount !== -1 &&
        this.foodFactsAmount[9] !== -1
          ? ((food.foodModel.foodFactModel.magnesium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[9]
          : 0;
      foodFactsAmount[10] =
        food.foodModel.foodFactModel.phosphor.amount !== -1 &&
        this.foodFactsAmount[10] !== -1
          ? ((food.foodModel.foodFactModel.phosphor.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[10]
          : 0;
      foodFactsAmount[11] =
        food.foodModel.foodFactModel.iron.amount !== -1 &&
        this.foodFactsAmount[11] !== -1
          ? ((food.foodModel.foodFactModel.iron.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[11]
          : 0;
      foodFactsAmount[12] =
        food.foodModel.foodFactModel.saturatedFat.amount !== -1 &&
        this.foodFactsAmount[12] !== -1
          ? ((food.foodModel.foodFactModel.saturatedFat.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[12]
          : 0;
      foodFactsAmount[13] =
        food.foodModel.foodFactModel.monounsaturatedFat.amount !== -1 &&
        this.foodFactsAmount[13] !== -1
          ? ((food.foodModel.foodFactModel.monounsaturatedFat.amount *
              food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[13]
          : 0;
      foodFactsAmount[14] =
        food.foodModel.foodFactModel.polyunsaturatedFat.amount !== -1 &&
        this.foodFactsAmount[14] !== -1
          ? ((food.foodModel.foodFactModel.polyunsaturatedFat.amount *
              food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[14]
          : 0;
      foodFactsAmount[15] =
        food.foodModel.foodFactModel.transFat.amount !== -1 &&
        this.foodFactsAmount[15] !== -1
          ? ((food.foodModel.foodFactModel.transFat.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[15]
          : 0;
      foodFactsAmount[16] =
        food.foodModel.foodFactModel.cholesterol.amount !== -1 &&
        this.foodFactsAmount[16] !== -1
          ? ((food.foodModel.foodFactModel.cholesterol.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[16]
          : 0;
    }
    foodFactsAmount.map((v, i) => {
      if (v === v && v % 1 !== 0) foodFactsAmount[i] = Number(v.toFixed(1));
    });
    return foodFactsAmount;
  }

  prepareFoodFactsPersianNames(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }

  prepareFoodFactsPersianUnits(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }

  checkCalorieAmount() {
    this.littleCalorie = 0;
    this.muchCalorie = 0;
    const ratio = this.planShared.selectedMealRatio.ratio;
    if (
      this.planShared.selectedDietCalorie * ratio * 0.01 * 0.95 >
      this.foodFactsAmount[0]
    ) {
      this.littleCalorie = Math.floor(
        this.planShared.selectedDietCalorie * ratio * 0.01 * 0.95 -
          this.foodFactsAmount[0]
      );
    }
    if (
      this.planShared.selectedDietCalorie * ratio * 0.01 * 1.05 <
      this.foodFactsAmount[0]
    ) {
      this.muchCalorie = Math.ceil(
        this.foodFactsAmount[0] -
          this.planShared.selectedDietCalorie * ratio * 0.01 * 1.05
      );
    }
  }

  back() {
    this.generateShared.previousUrl = '';
    this.planService.goBack();
  }

  showMoreFoodFacts() {
    this.foodFactsNamesBreif = this.foodFactsNames;
    this.morefoodFacts = true;
  }

  showLessFoodFacts() {
    this.foodFactsNamesBreif = [
      this.foodFactsNames[0],
      this.foodFactsNames[1],
      this.foodFactsNames[2],
      this.foodFactsNames[3],
    ];
    this.morefoodFacts = false;
  }

  openFoodEdit(food: FoodLogModel) {
    this.selectedFood = food;
    const bottomsheet = this.matBottomSheet.open(EditFoodBottomsheetComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        date: this.calendarShared.selectedDate.getTime(),
        food,
        dietId: this.dietId,
        day: this.day,
        meal: this.planShared.selectedMeal.meal,
        isPredefined: this.isPredefined,
        isCustome: food.calorie ? true : false,
      },
    });
    bottomsheet.afterDismissed().subscribe(() => {
      this.prepareValues();
    });
  }

  openFoodFactsDetail() {
    const emptyArray = new Array(17).fill(0);
    this.bottomsheetShared.selectedFoodName = this.selectedFood.foodModel.name;
    let ratio: FoodUnitRatioModel;
    let isGram = false;
    let primaryFoodUnit = '';
    if (this.selectedFood.unit) {
      primaryFoodUnit = this.selectedFood.unit;
    } else {
      primaryFoodUnit = this.selectedFood.foodModel.primaryFoodUnit;
    }
    if (
      primaryFoodUnit === '' ||
      primaryFoodUnit === '5e1c595d883a966e03fb4530'
    ) {
      isGram = true;
    }
    if (isGram) {
      ratio = new FoodUnitRatioModel(
        1,
        new FoodUnitIdModel('گرم', '5e1c595d883a966e03fb4530')
      );
    } else {
      this.selectedFood.foodModel.foodUnitRatioArray.forEach((r) => {
        if (r.unitId._id === primaryFoodUnit) {
          ratio = r;
        }
      });
    }
    if (isGram) {
      this.bottomsheetShared.selectedFoodSecondUnit =
        this.selectedFood.amount + ' ' + ratio.unitId.name;
    } else {
      this.bottomsheetShared.selectedFoodSecondUnit =
        this.selectedFood.amount +
        ' ' +
        ratio.unitId.name +
        ' معادل ' +
        ratio.ratio * this.selectedFood.amount +
        ' گرم است.';
    }
    this.bottomsheetShared.selectedFoodFactsAmounts =
      this.prepareFoodFactsAmounts(this.selectedFood, emptyArray, ratio);
    this.bottomsheetShared.selectedFoodFactsNames =
      this.prepareFoodFactsPersianNames(this.selectedFood);
    this.bottomsheetShared.selectedFoodFactsUnits =
      this.prepareFoodFactsPersianUnits(this.selectedFood);
    this.showFoodFactDetail = true;
  }

  consumed(notNeedAnimation?: boolean) {
    if (!notNeedAnimation) {
      this.clickAnimation();
    }
    this.showLoading = true;
    setTimeout(() => {
      this.planService
        .changeStatus(
          this.dietId,
          this.day,
          this.planShared.selectedMeal.meal,
          'consumed',
          true
        )
        .then(async (res) => {
          if (res.isSuccess()) {
            this.diaryAnalytics.analyticDiaryPackageStatusChanged(
              'consumed',
              this.day
            );
            this.status = 1;
            let foodlogList = [];
            this.planShared.selectedMeal.foods.forEach((food) => {
              foodlogList.push(
                new AddFoodLogInputModel(
                  this.calendarShared.selectedDate.getTime(),
                  food.amount,
                  food.food,
                  this.planShared.selectedMeal.meal,
                  food.foodModel.primaryFoodUnit,
                  this.planShared.selectedMeal._id
                )
              );
            });
            const result = await this.planService.addFood(foodlogList, true);
            if (result.isSuccess()) {
              // this.cdRef.detectChanges();
              this.prepareValues();
            }
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
    }, 100);
  }

  passed() {
    this.showLoading = true;
    this.planService
      .changeStatus(
        this.dietId,
        this.day,
        this.planShared.selectedMeal.meal,
        'passed',
        true
      )
      .then((res) => {
        if (res.isSuccess()) {
          this.status = -1;
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.showLoading = false;
      });
  }

  pendingDialog() {
    this.iosBottomsheetInput = new IosBottomsheetInputModel(
      ['بله'],
      'خیر',
      'آیا از خوردن این پکیج صرف نظر کردید؟',
      'pending'
    );
    this.showIosBottomsheet = true;
  }

  pending() {
    this.showLoading = true;
    setTimeout(() => {
      this.planService
        .changeStatus(
          this.dietId,
          this.day,
          this.planShared.selectedMeal.meal,
          'pending',
          true
        )
        .then(async (res) => {
          if (res.isSuccess()) {
            this.diaryAnalytics.analyticDiaryPackageStatusChanged(
              'pending',
              this.day
            );
            this.status = 0;
            let foodLogIds = [];
            for (const food of this.planShared.selectedMeal.foods) {
              for (const foodLog of this.planShared.selectedDietDayFoodLogs
                .foodLogs) {
                if (food.food === foodLog.food) {
                  foodLogIds.push(foodLog._id);
                }
              }
            }
            const result = await this.planService.removeFood(
              this.calendarShared.selectedDate.getTime(),
              foodLogIds,
              true
            );
            if (result.isSuccess()) {
              this.prepareValues();
            }
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
    }, 100);
  }

  changePackage() {
    this.plansService.openBottomSheet(
      this.planShared.selectedMeal.meal,
      this.dietId,
      this.day
    );
    // this.planService.goToChangeMeal(
    //   this.dietId,
    //   this.day,
    //   this.planShared.selectedMeal.meal
    // );
  }

  addFood() {
    if (
      this.isPredefined &&
      localStorage.getItem('predefined-diet-dialog') !== '1'
    ) {
      const data = {
        action: 'add',
        dietType: this.planShared.dietType,
      };
      const dialogRef = this.dialog.open(PredefinedDietDialogComponent, {
        data,
        width: '90%',
        panelClass: 'custom-dialog-container',
      });
    } else {
      this.planService.goToPersoanlpackage(
        this.dietId,
        this.day,
        this.planShared.selectedMeal.meal
      );
    }
  }

  goToShop() {
    this.shopService.goToShopPage('mealDetail');
  }

  goToCheatDay() {
    this.planService.goToCheatDay(
      this.dietId,
      this.day,
      true,
      this.cheatDayCount,
      this.isPredefined
    );
  }

  clickAnimation() {
    const element = document.getElementById('status-submit');
    element.style.width = 'calc( 100% - 40px )';
    element.style.right = '20px';
    element.style.height = '32px';
    element.style.bottom = '12px';
    setTimeout(() => {
      element.style.width = 'calc( 100% - 32px )';
      element.style.right = '16px';
      element.style.height = '40px';
      element.style.bottom = '8px';
    }, 100);
  }

  addZeroes(num: string) {
    const dec = num.split('.')[1];
    const len = dec ? (dec.length < 1 ? dec.length : 1) : 0;
    return Number(num).toFixed(len);
  }
}
